<template>
  <div>
    <!-- 题型1，大题下包含几个小题 -->
    <SubScale v-if="content.type==1" :content="content" v-on:listenToChildEvent="showMsg"></SubScale>
    <!-- 题型2，单选题-->
    <SelectRadio v-if="content.type==2" :content="content" v-on:listenToChildEvent="showMsg"></SelectRadio>
    <!-- 题型3，单选评分题 -->
    <MultipleStar v-if="content.type==7" :content="content" v-on:listenToChildEvent="showMsg"></MultipleStar>
    <!-- 题型4，联动题多选 -->
    <CheckBox v-if="content.type==4" :content="content" v-on:listenToChildEvent="showMsg"></CheckBox>
    <!-- 题型6 -->
    <TextInput v-if="content.type==6" :content="content" v-on:listenToChildEvent="showMsg"></TextInput>
  </div>
</template> <!--多答案-->
  <script>
    import SubScale from '../components/SubScale';
    import SelectRadio from '../components/SelectRadio'
    import MultipleStar from '../components/MultipleStar'
    import CheckBox from '../components/CheckBox'
    import TextInput from '../components/TextInput'
      export default {
        props:{
          content: Object
        },
        components: {
          'SubScale': SubScale,
          'SelectRadio':SelectRadio,
          'MultipleStar':MultipleStar,
          'CheckBox':CheckBox,
          'TextInput':TextInput
        },
        methods: {
          // 点击事件
          showMsg(index,num,type,s){
            this.$emit("listenToChildEvent", index, num, type, s);
          }
        }
      }
    </script>
    <style scoped>
    </style>
